import {IDocumentMetadata} from "./model/i-tax-return";
import {DocumentMetadata} from "../../../../swaggerServices";

const documentCache: {[docId: string]: IDocumentMetadata} = {};

export const getResolvedDocument = doc => {
  const resolvedDoc = documentCache[doc.id];
  if (resolvedDoc != null) {
    return {...resolvedDoc, url: doc.url};
  } else {
    return doc;
  }
};

export const updateDocumentCache = (docs: DocumentMetadata[]) => {
  docs.forEach(doc => {
    documentCache[doc.id] = doc;
  });
};

export const inDocumentCache = (docId: string) => documentCache[docId] != null;
